import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons/faExclamationTriangle';
import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { Button } from 'ui-components/components/button';
import { Modal } from 'ui-components/components/modal';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import asModal from '../../../../../components/as-modal';

import messages from '../messages';
import productMessages from '../../../messages';
import { clearProductImportLog } from '../../../../../store/products/products.actions';
import style from '../style.module.less';

const ImportLogModal = () => {
  const dispatch = useDispatch();

  const { importErrors } = useSelector((state) => state.products);
  const onClose = useCallback(() => {
    dispatch(clearProductImportLog());
  }, [dispatch]);

  return (
    <Modal size='medium'>
      <ModalHeader closeModal={onClose}>
        <FormattedMessage {...productMessages.importLogModalTitle} />
      </ModalHeader>
      <ModalBody className={style['product-import-modal']}>
        <FormattedMessage {...productMessages.importLogModaLContent} />
        <div className={style['import-log-errors']}>
          {importErrors.map((err, index) => (
            <p key={`importError${index}`}>
              <FontAwesomeIcon className={style.icon} icon={faExclamationTriangle} />
              {err}
            </p>
          ))}
        </div>
      </ModalBody>
      <ModalFooter>
        <Button onClick={onClose} theme='primary'>
          <FormattedMessage {...messages.close} />
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default asModal(ImportLogModal);
